import {z} from 'zod';

import {conversationDetail} from '../../modules/conversation/conversationDetail';

export const createConversationBody = z.object({
  tenantId: z.string().min(1, 'Tenant ID is required'),
  userIds: z
    .array(z.string().min(1, 'User ID cannot be empty'))
    .min(2, 'At least 2 users are required')
    .max(100, 'Maximum 100 users allowed'),
});

export type CreateConversationBody = z.infer<typeof createConversationBody>;

export const createConversationResponse = conversationDetail;

export type CreateConversationResponse = z.infer<typeof createConversationResponse>;
